import {
  addDays,
  now,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from './datetime';
import i18n from './i18n';

const getPredefinedDateRanges = () => {
  const today = now();
  const includeFutureResults = addDays(today, 90); // Quick-fix for the problem of filtering out future results

  return {
    last7Days: {
      end: includeFutureResults,
      label: i18n.t(($) => $.dateRange.last7Days, { ns: 'filters' }),
      start: addDays(today, -7),
    },
    last14Days: {
      end: includeFutureResults,
      label: i18n.t(($) => $.dateRange.last14Days, { ns: 'filters' }),
      start: addDays(today, -14),
    },
    last30Days: {
      end: includeFutureResults,
      label: i18n.t(($) => $.dateRange.last30Days, { ns: 'filters' }),
      start: addDays(today, -30),
    },
    last90Days: {
      end: includeFutureResults,
      label: i18n.t(($) => $.dateRange.last90Days, { ns: 'filters' }),
      start: addDays(today, -90),
    },
    last365Days: {
      end: includeFutureResults,
      label: i18n.t(($) => $.dateRange.last365Days, { ns: 'filters' }),
      start: addDays(today, -365),
    },
    thisMonth: {
      end: includeFutureResults,
      label: i18n.t(($) => $.dateRange.thisMonth, { ns: 'filters' }),
      start: startOfMonth(today),
    },
    thisWeek: {
      end: includeFutureResults,
      label: i18n.t(($) => $.dateRange.thisWeek, { ns: 'filters' }),
      start: startOfWeek(today, { weekStartsOn: 1 }),
    },
    thisYear: {
      end: includeFutureResults,
      label: i18n.t(($) => $.dateRange.thisYear, { ns: 'filters' }),
      start: startOfYear(today),
    },
    today: {
      end: includeFutureResults,
      label: i18n.t(($) => $.dateRange.today, { ns: 'filters' }),
      start: today,
    },
    yesterday: {
      end: addDays(today, -1),
      label: i18n.t(($) => $.dateRange.yesterday, { ns: 'filters' }),
      start: addDays(today, -1),
    },
  };
};

/**
 * Predefined date ranges for filtering the invoice reprocessing list.
 * @deprecated define this properly
 */
export const FILTER_DATE_RANGES = getPredefinedDateRanges();

export const DATE_RANGE_LABELS = Object.keys(FILTER_DATE_RANGES);

export type DateRangeLabel = keyof typeof FILTER_DATE_RANGES;
